import type { WhatsAppDestinationType } from '../models/automation-api.models';

/** Destinos em que o WhatsApp vai a um utilizador Taskeo (nome pode ser preenchido na execução). */
export function whatsAppDestinationUsesTaskeoUser(dest: WhatsAppDestinationType): boolean {
  return dest === 'PersonField' || dest === 'CardAssignee' || dest === 'CardCreator';
}

/** Chave da variável de nome da pessoa no config (alinhado aos templates Meta / API). */
export function isWhatsAppPersonNameVariableKey(key: string): boolean {
  return key.trim().toLowerCase() === 'personname';
}

/**
 * Validação alinhada à API: valor trim não vazio, exceto `personName` vazio quando o destino
 * é utilizador Taskeo (backend preenche na execução).
 */
export function isWhatsAppVariableSlotValueValid(
  variableKey: string,
  rawValue: string,
  destinationType: WhatsAppDestinationType
): boolean {
  const trimmed = (rawValue ?? '').trim();
  if (isWhatsAppPersonNameVariableKey(variableKey) && whatsAppDestinationUsesTaskeoUser(destinationType)) {
    return true;
  }
  return trimmed.length > 0;
}
